interface RangeSearchFiltersProps {
  fromLabel: string;
  toLabel: string;
  fromValue: string;
  toValue: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  searchLabel: string;
  searchPlaceholder?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onClear: () => void;
  isClearDisabled: boolean;
}

const RangeSearchFilters = ({
  fromLabel,
  toLabel,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  searchLabel,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  onClear,
  isClearDisabled,
}: RangeSearchFiltersProps) => (
  <div className="orders-filters">
    <label>
      <span>{fromLabel}</span>
      <input
        type="date"
        value={fromValue}
        onChange={(event) => onFromChange(event.target.value)}
      />
    </label>
    <label>
      <span>{toLabel}</span>
      <input
        type="date"
        value={toValue}
        onChange={(event) => onToChange(event.target.value)}
      />
    </label>
    <label className="orders-search">
      <span>{searchLabel}</span>
      <input
        type="search"
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={searchPlaceholder}
      />
    </label>
    <button
      type="button"
      className="secondary orders-filters-clear"
      onClick={onClear}
      disabled={isClearDisabled}
    >
      Wyczyść
    </button>
  </div>
);

export default RangeSearchFilters;
